import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "LogIn",
        components: {
            default: () => import("../views/LogIn.vue")
        }
    },

    {
        path: "/forgotpassword",
        name: "ForgotPassword",
        component: () => import("../views/ForgotPassword.vue")
    },

    {
        path: "/passwordsendconfirmation",
        name: "PasswordSendConfirmation",
        component: () => import("../views/PasswordSendConfirmation.vue")
    },

    {
        path: "/admin",
        name: "Admin",
        components: {
            header: () => import("../components/admin/Header.vue"),
            default: () => import("../views/admin/Admin.vue")
        },
        children: [
            {
                path: "dashboard",
                name: "Dashboard",
                component: () => import("../views/admin/Dashboard.vue")
            },

            {
                path: "courses",
                name: "Courses",
                component: () => import("../views/admin/Courses.vue")
            },
            {
                path: "lessons",
                name: "Lessons",
                component: () => import("../views/admin/Lessons.vue")
            },

            {
                path: "questions",
                name: "Questions",
                component: () => import("../views/admin/Questions.vue")
            },

            {
                // path: "modifyquestionsinalesson/:lesson_id",
                path: "modifyquestions",
                name: "ModifyQuestionsInALesson",
                component: () =>
                    import("../views/admin/ModifyQuestionsInALesson.vue")
            },

            {
                //path: "modifylessonsinacourse/:course_id",
                path: "modifylessons",
                name: "ModifyLessonsInACourse",
                component: () =>
                    import("../views/admin/ModifyLessonsInACourse.vue")
            },

            {
                path: "courseinfoedit",
                name: "CourseInfoEdit",
                //props:true,
                component: () => import("../views/admin/CourseInfoEdit.vue")
            },

            {
                // path: "lessoninfoedit/:lesson_id",
                path: "lessoninfoedit",
                name: "LessonInfoEdit",
                //props:true,
                component: () => import("../views/admin/LessonInfoEdit.vue")
            },
            {
                //path: "questioninfoedit/:question_id",
                path: "questioninfoedit",
                name: "QuestionInfoEdit",
                //props:true,
                component: () => import("../views/admin/QuestionInfoEdit.vue")
            },

            {
                path: "addcourse",
                name: "AddCourse",
                component: () => import("../views/admin/AddCourse.vue")
            },
            {
                path: "addlesson",
                name: "AddLesson",
                component: () => import("../views/admin/AddLesson.vue")
            },
            {
                path: "addquestion",
                name: "AddQuestion",
                component: () => import("../views/admin/AddQuestion.vue")
            },

            {
                path: "editadminuserprofile",
                name: "EditAdminUserProfile",
                component: () =>
                    import("../views/admin/EditAdminUserProfile.vue")
            },
            {
                path: "lessoninfo/:lesson_id",
                name: "LessonInfo",
                props: true,
                component: () => import("../views/admin/LessonInfo.vue")
            },
            {
                path: "questioninfo/:question_id/:questionType",
                name: "QuestionInfo",
                props: true,
                component: () => import("../views/admin/QuestionInfo.vue")
            },

            {
                path: "locationfeedback",
                name: "LocationFeedback",
                component: () => import("../views/admin/LocationFeedback.vue")
            },
            {
                path: "termsandcondition",
                name: "TermsAndCondition",
                component: () => import("../views/admin/TermsAndCondition.vue")
            },
            {
                path: "privacypolicy",
                name: "privacypolicy",
                component: () => import("../views/admin/PrivacyPolicy.vue")
            },
            {
                path: "about",
                name: "about",
                component: () => import("../views/admin/About.vue")
            },
            {
                path: "theorynotes",
                name: "theorynotes",
                component: () => import("../views/admin/TheoryNotes.vue")
            },
            {
                path: "users",
                name: "users",
                component: () => import("../views/admin/Users.vue")
            },
            {
                path: "payments",
                name: "payments",
                component: () => import("../views/admin/Payments.vue")
            },

            {
                path: "packageprice",
                name: "packageprice",
                component: () => import("../views/admin/PackagePrice.vue")
            },
            {
                path: "reminderpopups",
                name: "reminderpopups",
                component: () => import("../views/admin/ReminderPopup.vue")
            },
            {
                path: "discounts",
                name: "discounts",
                component: () => import("../views/admin/Discount.vue")
            },
            {
                path: "seasonaldiscounts",
                name: "seasonaldiscounts",
                component: () => import("../views/admin/SeasonalDiscounts.vue")
            },
            {
                path: "addseasonaldiscount",
                name: "AddSeasonalDiscount",
                component: () => import("../views/admin/AddSeasonalDiscount.vue")
            },
            {
                path: "seasonalinfoedit",
                name: "EditSeasonalDiscount",
                component: () => import("../views/admin/EditSeasonalDiscount.vue")
            },
            

            {
                path: "specialdiscounts",
                name: "specialdiscounts",
                component: () => import("../views/admin/SpecialDiscounts.vue")
            },
            {
                path: "addspecialdiscount",
                name: "AddSpecialDiscount",
                component: () => import("../views/admin/AddSpecialDiscount.vue")
            },


            {
                path: "groupdiscounts",
                name: "groupdiscounts",
                component: () => import("../views/admin/GroupDiscounts.vue")
            },

            {
                path: "addgroupdiscount",
                name: "AddGroupDiscount",
                component: () => import("../views/admin/AddGroupDiscount.vue")
            },



        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

export default router;
